// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase, new-cap, babel/new-cap, func-names, default-param-last, init-declarations, no-negated-condition, no-implicit-coercion, radix, no-plusplus, multiline-comment-style, no-param-reassign, prefer-destructuring */
import { List, Set } from "immutable"
import * as R from "ramda"
import { differenceInDays } from "date-fns"

import { getUTCDate } from "../momentHelpers/momentHelpers"
import { get, getOr } from "../../utils/get"
import has from "../../utils/has"
import isUndefined from "../../utils/isUndefined"
import isEmpty from "../../utils/isEmpty"
import cuckoo from "../cuckoo/cuckoo"
import Trip from "../../records/Trip"
import JourneyProvider from "../../records/JourneyProvider"
import Journey from "../../records/Journey"
import mapperFlight from "./mapperFlight"
import mapperTransfer from "./mapperTransfer"
import { cuckooEvents } from "../../consts/enums"
import {
  PROVIDER_EXCLUDE_BOOKING,
  PROVIDER_KIWI_NAME,
  PROVIDER_KIWI_CODE,
} from "../../consts/providerConsts"
import type Place from "../../records/Place"
import type { Splitster } from "../../types/splitster"
import {
  filterHiddenFlightOut,
  formatForHiddenFlightsMapping,
  hasThrowawayTicketOrHiddenCity,
  hiddenFlightFormattingSupported,
  hasHiddenCity,
} from "./journeyHiddenFlightTools"

const APIS = {
  CHECK_FLIGHTS_API: "check_flights",
  FLIGHTS_API: "flights",
  BOOKING_API: "bookings",
  TRANSFERS_API: "transfers",
} as const

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function determineApiFormat(flightObj: any) {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (has("src.airport", flightObj) && has("dst.airport", flightObj)) {
    return APIS.TRANSFERS_API
  }
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (flightObj && has("src", flightObj) && has("dst", flightObj)) {
    return APIS.CHECK_FLIGHTS_API
  }
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (has("departure.where.code", flightObj) && has("arrival.where.code", flightObj)) {
    return APIS.BOOKING_API
  }
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (flightObj && has("flyFrom", flightObj) && has("flyTo", flightObj)) {
    return APIS.FLIGHTS_API
  }
  return null
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function extractArrivalCode(flightObj: any) {
  switch (determineApiFormat(flightObj)) {
    case APIS.TRANSFERS_API:
      return flightObj.dst.airport
    case APIS.CHECK_FLIGHTS_API:
      return flightObj.dst
    case APIS.BOOKING_API:
      return flightObj.arrival.where.code
    case APIS.FLIGHTS_API:
      return flightObj.flyTo
    default:
      return ""
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function extractDepartureCode(flightObj: any) {
  switch (determineApiFormat(flightObj)) {
    case APIS.TRANSFERS_API:
      return flightObj.src.airport
    case APIS.CHECK_FLIGHTS_API:
      return flightObj.src
    case APIS.BOOKING_API:
      return flightObj.departure.where.code
    case APIS.FLIGHTS_API:
      return flightObj.flyFrom
    default:
      return ""
  }
}

export function fillPlacesToFlightObjMutable(
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  flightObj: any,

  places: Map<string, Place>,

  placesInEnglish: Map<string, Place>,
) {
  // @ts-expect-error: Flow to TS migration.
  if (places.get(flightObj.src) && places.get(flightObj.src).get("city")) {
    flightObj.src_name_original = flightObj.src_name
    // @ts-expect-error: Flow to TS migration.
    flightObj.src_name = places.get(flightObj.src).get("city").name
    // @ts-expect-error: Flow to TS migration.
    flightObj.src_city = places.get(flightObj.src).get("city").id
  }
  // @ts-expect-error: Flow to TS migration.
  if (places.get(flightObj.dst) && places.get(flightObj.dst).get("city")) {
    flightObj.dst_name_original = flightObj.dst_name
    // @ts-expect-error: Flow to TS migration.
    flightObj.dst_name = places.get(flightObj.dst).get("city").name
    // @ts-expect-error: Flow to TS migration.
    flightObj.dst_city = places.get(flightObj.dst).get("city").id
  }
  // @ts-expect-error: Flow to TS migration.
  flightObj.src_station = places.get(flightObj.src).get("station") || flightObj.src_station
  // @ts-expect-error: Flow to TS migration.
  flightObj.dst_station = places.get(flightObj.dst).get("station") || flightObj.dst_station

  // @ts-expect-error: Flow to TS migration.
  flightObj.src_location_id = places.get(flightObj.src).id
  // @ts-expect-error: Flow to TS migration.
  flightObj.src_location_type = places.get(flightObj.src).typeName
  // @ts-expect-error: Flow to TS migration.
  flightObj.src_region = places.get(flightObj.src).region
  // @ts-expect-error: Flow to TS migration.
  flightObj.src_continent = places.get(flightObj.src).continent
  // @ts-expect-error: Flow to TS migration.
  flightObj.dst_location_id = places.get(flightObj.dst).id
  // @ts-expect-error: Flow to TS migration.
  flightObj.dst_location_type = places.get(flightObj.dst).typeName
  // @ts-expect-error: Flow to TS migration.
  flightObj.dst_region = places.get(flightObj.dst).region
  // @ts-expect-error: Flow to TS migration.
  flightObj.dst_continent = places.get(flightObj.dst).continent

  // @ts-expect-error: Flow to TS migration.
  if (placesInEnglish.get(flightObj.src) && placesInEnglish.get(flightObj.src).get("city")) {
    // @ts-expect-error: Flow to TS migration.
    flightObj.src_name_english = placesInEnglish.get(flightObj.src).get("city").name
    // @ts-expect-error: Flow to TS migration.
    flightObj.src_region_english = placesInEnglish.get(flightObj.src).region
    // @ts-expect-error: Flow to TS migration.
    flightObj.src_continent_english = placesInEnglish.get(flightObj.src).continent
  }

  // @ts-expect-error: Flow to TS migration.
  if (placesInEnglish.get(flightObj.dst) && placesInEnglish.get(flightObj.dst).get("city")) {
    // @ts-expect-error: Flow to TS migration.
    flightObj.dst_name_english = placesInEnglish.get(flightObj.dst).get("city").name
    // @ts-expect-error: Flow to TS migration.
    flightObj.dst_region_english = placesInEnglish.get(flightObj.dst).region
    // @ts-expect-error: Flow to TS migration.
    flightObj.dst_continent_english = placesInEnglish.get(flightObj.dst).continent
  }
}

export default function (
  // FIXME: add "@flow" annotation to this file for type checking to work

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rawInput: Record<any, any>,
  // FIXME: add "@flow" annotation to this file for type checking to work

  requestSource: string | null | undefined,
  // FIXME: add "@flow" annotation to this file for type checking to work

  disableHiddenFlightsFiltering: boolean | null | undefined = false,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  airlines: any,
  // FIXME: add "@flow" annotation to this file for type checking to work

  splitster: Splitster,
) {
  const shouldMapHiddenFlights =
    disableHiddenFlightsFiltering &&
    hasThrowawayTicketOrHiddenCity(rawInput) &&
    hiddenFlightFormattingSupported(rawInput)

  let hasHoldBagsAllowed

  const input = shouldMapHiddenFlights
    ? formatForHiddenFlightsMapping(rawInput) // format for hidden flights
    : filterHiddenFlightOut(rawInput) // filter out hidden flights by default

  // @ts-expect-error: Flow to TS migration.
  if (!R.isNil(input.cabin_baggage_only)) {
    // @ts-expect-error: Flow to TS migration.
    hasHoldBagsAllowed = !input.cabin_baggage_only
  } else if (get(["route", 0, "route"], input)) {
    // multicity and salesman
    // @ts-expect-error: Flow to TS migration.
    if (input.bags_price) {
      // is salesman
      // @ts-expect-error: Flow to TS migration.
      hasHoldBagsAllowed = !isEmpty(input.bags_price)
    } else {
      // is multicity
      // @ts-expect-error: Flow to TS migration.
      hasHoldBagsAllowed = input.route.every((x) => !isEmpty(x.bags_price))
    }
    // mmb
  } else if (get(["baggages", "notices", "hold_bags_disabled_reason"], input)) {
    hasHoldBagsAllowed = false
    // @ts-expect-error: Flow to TS migration.
  } else if (!R.isNil(input.bags_price)) {
    // @ts-expect-error: Flow to TS migration.
    hasHoldBagsAllowed = !isEmpty(input.bags_price)
  } else {
    hasHoldBagsAllowed = true
  }

  // input.searchProvider is set from Umbrella, when using flights API & meta search, source is same for whole request
  // @ts-expect-error: Flow to TS migration.
  const source = input.searchProvider || requestSource

  let journey = new Journey({
    // @ts-expect-error: Flow to TS migration.
    bookingToken: input.booking_token,
    hasHoldBagsAllowed,
    // @ts-expect-error: Flow to TS migration.
    debugColor: input.debugColor,
    // @ts-expect-error: Flow to TS migration.
    debugString: input.debugString,
    // @ts-expect-error: Flow to TS migration.
    id: input.id,
    _original: input,
    sources: Set([source]),
    // @ts-expect-error: Flow to TS migration.
    quality: input.quality,
    disabledBagsInMmb: getOr(false, "disabled_bags_in_mmb", input),
    hiddenFlightsType: getOr(null, "hiddenFlightsType", input),
    countryFrom: getOr("", ["countryFrom", "code"], input),
    countryTo: getOr("", ["countryTo", "code"], input),
  })

  // @ts-expect-error: Flow to TS migration.
  if (R.is(Number, input.price)) {
    // @ts-expect-error: Flow to TS migration.
    journey = journey.setIn(["prices", "default"], input.price)
    // @ts-expect-error: Flow to TS migration.
  } else if (!isEmpty(input.price)) {
    // @ts-expect-error: Flow to TS migration.
    journey = journey
      // @ts-expect-error: Flow to TS migration.
      .setIn(["prices", "default"], input.price.paid_by_pap)
      // @ts-expect-error: Flow to TS migration.
      .setIn(["prices", "paidByKiwi"], input.price.paid_by_kiwi)
  }

  // @ts-expect-error: Flow to TS migration.
  if (input.price_adjustments?.original_price != null) {
    // @ts-expect-error: Flow to TS migration.
    journey = journey.setIn(["prices", "original"], Number(input.price_adjustments.original_price))
  }

  // @ts-expect-error: Flow to TS migration.
  if (!isUndefined(input.visa_check_required_for)) {
    // @ts-expect-error: Flow to TS migration.
    journey = journey.set("visaCheckRequiredFor", input.visa_check_required_for)
  }

  // @ts-expect-error: Flow to TS migration.
  if (!isUndefined(input.hold_bags_disabled)) {
    // @ts-expect-error: Flow to TS migration.
    journey = journey.set("holdBagsDisabled", input.hold_bags_disabled)
  }

  // @ts-expect-error: Flow to TS migration.
  journey = journey.set("hasHiddenCity", hasHiddenCity(input))

  // Search uses this mapper, they don't have flights
  if (input.flights) {
    const prioFlights = input.flights.filter(
      // @ts-expect-error: Flow to TS migration.
      (flightObj) => flightObj.forced_priority_boarding && flightObj.airline.code === "FR",
    )

    const prioBoardingNeededForCabinBag = prioFlights.length > 0

    const daysUntilFirstDeparture = prioBoardingNeededForCabinBag
      ? // @ts-expect-error: Flow to TS migration.
        differenceInDays(getUTCDate(prioFlights[0].dtime * 1000), getUTCDate())
      : undefined

    if (
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      splitster &&
      hasHoldBagsAllowed &&
      prioBoardingNeededForCabinBag &&
      // @ts-expect-error: Flow to TS migration.
      daysUntilFirstDeparture < 10
    ) {
      // @ts-expect-error: Flow to TS migration.
      cuckoo.track(cuckooEvents.BOOKING_PB_SOLD_OUT_MARKED_FLIGHTS)
      if (splitster.get("PB_SOLD_OUT").value === "on") {
        input.flights.forEach((flightObj) => {
          // @ts-expect-error: Flow to TS migration.
          flightObj.forced_priority_boarding = false

          // If prio boarding ancillary is defined for this flight, turn it off
          if (
            // Fix this the next time the file is edited. (Flow to TS)
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            R.pathOr(
              false,
              // @ts-expect-error: Flow to TS migration.
              ["additional_services", "priority_boarding", "data", flightObj.id, "is_possible"],
              rawInput,
            )
          ) {
            // @ts-expect-error: Flow to TS migration.
            rawInput.additional_services.priority_boarding.data[flightObj.id].is_possible = false
          }
        })
      }
    }
  }

  let isMulticity
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let tripObjs: any = []
  // @ts-expect-error: Flow to TS migration.
  if (typeof input.segments === "object") {
    // Fix this the next time the file is edited. (Flow to TS)
    // @ts-expect-error: Flow to TS migration.
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    isMulticity = !!(input.segments && input.segments.length && !input.flights.some(get("return")))

    if (isMulticity) {
      // @ts-expect-error: Flow to TS migration.
      input.flights.forEach((flightObj, flightIndex) => {
        let tripIndex = 0
        // @ts-expect-error: Flow to TS migration.
        while (input.segments[tripIndex] && flightIndex >= parseInt(input.segments[tripIndex])) {
          tripIndex++
        }
        if (!tripObjs[tripIndex]) tripObjs[tripIndex] = []
        // FIXME: a method has been detected that possibly mutates the object, consider a more
        // functional approach (Ramda might help)

        tripObjs[tripIndex].push(flightObj)
      })
    } else {
      // @ts-expect-error: Flow to TS migration.
      input.flights.forEach((flightObj) => {
        const tripIndex = flightObj.return ? 1 : 0
        if (!tripObjs[tripIndex]) tripObjs[tripIndex] = []
        // FIXME: a method has been detected that possibly mutates the object, consider a more
        // functional approach (Ramda might help)

        tripObjs[tripIndex].push(flightObj)
      })
    }
  } else if (Array.isArray(input.route)) {
    // TODO: Check
    /*
     If Multicity, structure is like:
      { ...
        route: [
          { ..., route: [{flightObj}, {flightObj}, ...] }
        ]
      }

      if not Multicity, structure is like
      { ...
        route: [
          { flightObj: ..., return: 0 }
        ]
      }
    */
    // @ts-expect-error: Flow to TS migration.
    isMulticity = input.route.some((x) => x.route !== undefined)
    if (isMulticity) {
      // @ts-expect-error: Flow to TS migration.
      tripObjs = input.route.map((t) => t.route)
    } else {
      tripObjs = []
      input.route.forEach((flightObj) => {
        const tripIndex = flightObj.return ? 1 : 0
        if (!tripObjs[tripIndex]) tripObjs[tripIndex] = []
        // FIXME: a method has been detected that possibly mutates the object, consider a more
        // functional approach (Ramda might help)

        tripObjs[tripIndex].push(flightObj)
      })
    }
  } else if (
    // New format: array of array
    Array.isArray(get("trips", input)) &&
    Array.isArray(get(["trips", 0], input))
  ) {
    isMulticity = true // SHOT, alternatives currently don't receive information about segments/multicity journeys, so we display everything as multicity
    // @ts-expect-error: Flow to TS migration.
    tripObjs = input.trips
  } else {
    cuckoo.error(cuckooEvents.INTERNAL_MAPPER_JOURNEY_UNSUPPORTED_FORMAT, { input })
  }

  // we totally do not want to have a journey with no trips...
  // workaround for graphql returning this instead of empty results
  // {"data":{"get_flights_multi":[{"price":null,"deep_link":null,"booking_token":null,"route":[]}]},"invalid":false}
  if (tripObjs.length === 0) return null

  // @ts-expect-error: Flow to TS migration.
  const { transfers } = input
  // @ts-expect-error: Flow to TS migration.
  const containsTransfers = typeof input.transfers === "object"

  // We want to filter out empty trips
  // @ts-expect-error: Flow to TS migration.
  tripObjs.filter(Boolean).forEach((tripObj, tripIndex) => {
    // @ts-expect-error: Flow to TS migration.
    journey = journey.setIn(["trips", tripIndex], new Trip())

    // One API is not returning flights sorted, fix it
    // TODO: Add assertion to API layer, make backend fix it and then remove this
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (get([0, "dTimeUTC"], tripObj)) tripObj = R.sortBy(get("dTimeUTC"), tripObj)

    let prevArrivalCode = ""

    // @ts-expect-error: Flow to TS migration.
    tripObj.forEach((flightObj, flightIndex) => {
      // FLIGHTS MAPPER
      // @ts-expect-error: Flow to TS migration.
      journey = journey.updateIn(["trips", tripIndex, "flights"], (flights) =>
        // FIXME: a method has been detected that possibly mutates the object, consider a more
        // functional approach (Ramda might help)

        // @ts-expect-error: Flow to TS migration.
        flights.push(mapperFlight(flightObj, input.passengers, airlines)),
      )

      // PARTS MAPPER (flights with transfers together)
      const currDepartureCode = extractDepartureCode(flightObj)

      if (containsTransfers && prevArrivalCode !== currDepartureCode && !!flightIndex) {
        const transfer = transfers[0]
        if (
          extractDepartureCode(transfer) === prevArrivalCode &&
          extractArrivalCode(transfer) === currDepartureCode
        ) {
          // FIXME: a method has been detected that possibly mutates the object, consider a more
          // functional approach (Ramda might help)

          transfers.shift()
          // @ts-expect-error: Flow to TS migration.
          journey = journey.updateIn(["trips", tripIndex, "parts"], (flights) =>
            // FIXME: a method has been detected that possibly mutates the object, consider a more
            // functional approach (Ramda might help)

            flights.push(mapperTransfer(transfer)),
          )
        }
      }

      // @ts-expect-error: Flow to TS migration.
      journey = journey.updateIn(["trips", tripIndex, "parts"], (flights) =>
        // FIXME: a method has been detected that possibly mutates the object, consider a more
        // functional approach (Ramda might help)

        // @ts-expect-error: Flow to TS migration.
        flights.push(mapperFlight(flightObj, input.passengers, airlines)),
      )
      prevArrivalCode = extractArrivalCode(flightObj)
    })
    return tripObj
  })

  // @ts-expect-error: Flow to TS migration.
  if (Array.isArray(input.transfers)) {
    // @ts-expect-error: Flow to TS migration.
    input.transfers.forEach((transferObj) => {
      // FIXME: a method has been detected that possibly mutates the object, consider a more
      // functional approach (Ramda might help)

      // @ts-expect-error: Flow to TS migration.
      journey = journey.updateIn(["transfers"], (tfers) => tfers.push(mapperTransfer(transferObj)))
    })
  } else {
    // cuckoo.info("General: Journey mapper: Transfers not in response")
  }

  let type = "return"

  if (isMulticity) {
    type = "multicity"
  } else if (journey.get("trips").size === 1) {
    type = "oneWay"
  }

  // @ts-expect-error: Flow to TS migration.
  journey = journey.set("type", type)
  // @ts-expect-error: Flow to TS migration.
  if (Array.isArray(input.providers) && input.providers.length) {
    // @ts-expect-error: Flow to TS migration.
    const excludedProviders = PROVIDER_EXCLUDE_BOOKING[source] || []

    const providers = List(
      // @ts-expect-error: Flow to TS migration.
      input.providers
        // @ts-expect-error: Flow to TS migration.
        .map((provider) => JourneyProvider.fromPlainJS({ ...provider, source }))
        // @ts-expect-error: Flow to TS migration.
        .filter((provider) => !excludedProviders.some((excl) => provider.code === excl)),
      // @ts-expect-error: Flow to TS migration.
    ).sortBy((provider) => provider.price)

    if (providers.isEmpty()) {
      return null
    }

    // @ts-expect-error: Flow to TS migration.
    journey = journey.set("providers", providers)
  } else if (source === "kiwi") {
    // @ts-expect-error: Flow to TS migration.
    journey = journey.set(
      "providers",
      List([
        // @ts-expect-error: Flow to TS migration.
        JourneyProvider.fromPlainJS({
          name: PROVIDER_KIWI_NAME,
          code: PROVIDER_KIWI_CODE,
          price: journey.getPrice(),
          source,
        }),
      ]),
    )
  }

  return journey
}
